import { useMutation } from "@tanstack/react-query";
import type { UseMutationOptions, UseMutationResult } from "@tanstack/react-query";
import { customFetch } from "./custom-fetch";
import type { ErrorType } from "./custom-fetch";

export const duplicateEstimate = async (id: number): Promise<{ id: number }> => {
  return customFetch<{ id: number }>(`/api/estimates/${id}/duplicate`, {
    method: "POST",
  });
};

export const useDuplicateEstimate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<{ id: number }, TError, { id: number }, TContext>;
}): UseMutationResult<{ id: number }, TError, { id: number }, TContext> => {
  const { mutation: mutationOptions } = options ?? {};
  return useMutation<{ id: number }, TError, { id: number }, TContext>({
    mutationFn: ({ id }) => duplicateEstimate(id),
    ...mutationOptions,
  });
};
